<!--领队报名时  选择成员-->
<template>
  <div>
    <div>
      <van-nav-bar
        title="选择成员"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div style="background: #fff;">
      <div
        style="text-align: center;padding: 10px;font-size: 15px;font-weight: 600;border-bottom: 1px solid #e1e1e1;margin-left: 10px;
    margin-right: 10px;"
      >
        {{ SSMC }}
      </div>
      <van-cell
        title="项目"
        :value="
          XMMAP.XMJC + '(' + XMMAP.ISXB !== 'Y'
            ? XMMAP.SSLX === 'MD' ||
              XMMAP.SSLX === 'WD' ||
              XMMAP.SSLX === 'XD' ||
              XMMAP.SSLX === 'SD'
              ? '双打'
              : XMMAP.SSLX === 'MS' ||
                XMMAP.SSLX === 'WS' ||
                XMMAP.SSLX === 'XS' ||
                XMMAP.SSLX === 'SS'
              ? '单打'
              : '团体'
            : XMMAP.SSLXMC + ')'
        "
      />
      <div style="padding: 15px;" v-if="ISTEAM">
        <p style="margin-top: 10px;margin-bottom: 5px;font-size: 15px;">
          团体赛出场顺序：
        </p>
        <div>
          <span v-for="(item, index) in teamCsSxList" :key="index"
            >{{ item.SSLXMC }}、</span
          >
        </div>
      </div>
    </div>

    <van-row>
      <div style="margin: 15px;">
        <div style="float:left;font-size:14px">
          <label>队伍信息</label>
        </div>
        <div style="float:right;font-size:14px">
          <label></label>
        </div>
      </div>
    </van-row>
    <div style="margin-top:15px">
      <van-cell title="队伍全称" :value="DWXX.DWQC" />
      <van-cell title="队伍简称" :value="DWXX.DWJC" />
      <van-cell title="是否收费" :value="XMMAP.ISSF === '0' ? '否' : '是'" />
      <van-cell title="收费标准" :value="XMMAP.SFJE + '元/人或对'" />
      <van-cell
        title="备注"
        value="收取报名的比赛，领队无法指定队员，请采用邀请队员的模式进行名单采集"
        v-if="XMMAP.ISSF === '1'"
      />
    </div>

    <!-- 单项单打  开始 -->
    <div v-if="sslxType === 'S' || sslxType === 'T'">
      <!-- 男生数量  开始 -->
      <div style="padding:16px;" v-if="MRYLIST.length > 0">
        <van-row>
          <div>
            <div style="float:left;font-size:14px">
              <label
                >男（共{{ MRYLIST.length }}人&nbsp;&nbsp;已报名<span
                  style="color:red;font-size:16px;"
                >
                  {{ mYbrs }} </span
                >人&nbsp;&nbsp;未报名<span style="color:red;font-size:16px;">
                  {{ MRYLIST.length - mYbrs }} </span
                >人）</label
              >
            </div>
          </div>
        </van-row>
      </div>

      <div style="background: #fff;">
        <div style="margin-left:10px;margin-right:10px;">
          <van-checkbox-group
            v-model="selectRyidCheckBoxDatas"
            @change="boxChangeHandler"
          >
            <van-grid :border="true" :column-num="3">
              <van-grid-item v-for="(item, index) in MRYLIST" :key="index">
                <div style="position: relative;text-align: center;">
                  <van-checkbox
                    :disabled="item.ISPAY === '1' || XMMAP.ISSF === '1'"
                    :name="item.RYID + '|' + item.XB + '|' + item.RYXM"
                  >
                    <img
                      :src="item.TXURL"
                      style="width: 2.5rem;height: 2.5rem;border-radius: 100%;"
                    />
                    <p
                      style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;"
                    >
                      {{ item.RYXM
                      }}<span
                        v-if="item.AGE.length > 0 && parseInt(item.AGE) > 0"
                        >({{ item.AGE }}岁)</span
                      >
                    </p>
                  </van-checkbox>
                </div>
              </van-grid-item>
            </van-grid>
          </van-checkbox-group>
        </div>
      </div>

      <!-- 男生数量  结束 -->

      <!-- 女生数量  开始 -->
      <div style="padding:16px;" v-if="WRYLIST.length > 0">
        <van-row>
          <div>
            <div style="float:left;font-size:14px">
              <label
                >女（共{{ WRYLIST.length }}人&nbsp;&nbsp;已报名<span
                  style="color:red;font-size:16px;"
                >
                  {{ wYbrs }} </span
                >人&nbsp;&nbsp;未报名<span style="color:red;font-size:16px;">
                  {{ WRYLIST.length - wYbrs }} </span
                >人）</label
              >
            </div>
            <div style="float:right;font-size:14px;display:none">
              <label>点击头像查看详情</label>
            </div>
          </div>
        </van-row>
      </div>

      <div style="background: #fff;">
        <div style="margin-left:10px;margin-right:10px;">
          <van-checkbox-group
            v-model="selectRyidCheckBoxDatas"
            @change="boxChangeHandler"
          >
            <van-grid :border="true" :column-num="3">
              <van-grid-item v-for="(item, index) in WRYLIST" :key="index">
                <div style="position: relative;text-align: center;">
                  <van-checkbox
                    :disabled="item.ISPAY === '1' || XMMAP.ISSF === '1'"
                    :name="item.RYID + '|' + item.XB + '|' + item.RYXM"
                  >
                    <img
                      :src="item.TXURL"
                      style="width: 2.5rem;height: 2.5rem;border-radius: 100%;"
                    />
                    <p
                      style="margin-top: 10px;margin-bottom: 6px;font-size: 14px;"
                    >
                      {{ item.RYXM
                      }}<span
                        v-if="item.AGE.length > 0 && parseInt(item.AGE) > 0"
                        >({{ item.AGE }}岁)</span
                      >
                    </p>
                  </van-checkbox>
                </div>
              </van-grid-item>
            </van-grid>
          </van-checkbox-group>
        </div>
      </div>

      <!-- 女生数量  结束 -->
    </div>
    <!-- 单项单打  结束 -->

    <!-- 单项双打  开始 -->
    <div v-if="sslxType === 'D'" style="margin-top:15px;">
      <div
        style="margin-bottom:10px;text-align: right;padding-right: 15px;color: #089748;"
        @click="sslxDoubleAddCy"
        v-if="XMMAP.ISSF === '0'"
      >
        <van-icon name="add" />&nbsp;添加组队人员
      </div>
      <van-collapse v-model="sslxDoubleModal.activeNames">
        <van-collapse-item
          :title="
            item.length > 0 && item.indexOf('&') > -1
              ? item.split('&')[0].split('|')[2] +
                '/' +
                item.split('&')[1].split('|')[2]
              : '请选择人员'
          "
          :name="index"
          value=""
          v-for="(item, index) in selectRyidCheckBoxDatas"
          :key="index"
        >
          <div style="border-bottom: 1px solid #ddd;">
            <div
              style="margin-bottom:10px;text-align: right;padding-right: 15px;color: red;"
              @click="sslxDoubleRemoveCy(index)"
              v-if="XMMAP.ISSF === '0'"
            >
              <van-icon name="clear" />&nbsp;移除本组人员
            </div>
            <van-row>
              <van-col :span="12">
                <div style="background: #fff;">
                  <div style="text-align: center;">
                    左侧队员<span v-if="XMMAP.ISXB === 'Y'">
                      ({{
                        sslxDoubleXb === "M"
                          ? "男"
                          : sslxDoubleXb === "W"
                          ? "女"
                          : "男"
                      }})
                    </span>
                  </div>
                  <div
                    style="margin-left:10px;margin-right:10px;border-right: 3px solid #ddd;"
                  >
                    <van-radio-group
                      v-model="sslxDoubleModal.leftRadioRys[index]"
                      @change="radioChangeHandler('L', index)"
                    >
                      <van-grid :border="true" :column-num="2">
                        <van-grid-item
                          v-for="(item, index) in sslxDoubleModal.allRyLeftList"
                          :key="index"
                        >
                          <div style="position: relative;text-align: center;">
                            <van-radio
                              :name="
                                item.RYID + '|' + item.XB + '|' + item.RYXM
                              "
                            >
                              <img
                                :src="item.TXURL"
                                style="width: 2.5rem;height: 2.5rem;border-radius: 100%;"
                              />
                              <p
                                style="margin-top: 10px;margin-bottom: 3px;font-size: 14px;"
                              >
                                {{ item.RYXM }}
                              </p>
                              <p
                                v-if="
                                  item.AGE.length > 0 && parseInt(item.AGE) > 0
                                "
                                style="margin-top: 0px;margin-bottom: 3px;"
                              >
                                ({{ item.AGE }}岁)
                              </p>
                            </van-radio>
                          </div>
                        </van-grid-item>
                      </van-grid>
                    </van-radio-group>
                  </div>
                </div>
              </van-col>
              <van-col :span="12">
                <div style="background: #fff;">
                  <div style="text-align: center;">
                    右侧队员
                    <span v-if="XMMAP.ISXB === 'Y'">
                      ({{
                        sslxDoubleXb === "M"
                          ? "男"
                          : sslxDoubleXb === "W"
                          ? "女"
                          : "女"
                      }})
                    </span>
                  </div>
                  <div style="margin-left:3px;margin-right:3px;">
                    <van-radio-group
                      v-model="sslxDoubleModal.rightRadioRys[index]"
                      @change="radioChangeHandler('R', index)"
                    >
                      <van-grid :border="true" :column-num="2">
                        <van-grid-item
                          v-for="(item,
                          index) in sslxDoubleModal.allRyRightList"
                          :key="index"
                        >
                          <div style="position: relative;text-align: center;">
                            <van-radio
                              :name="
                                item.RYID + '|' + item.XB + '|' + item.RYXM
                              "
                            >
                              <img
                                :src="item.TXURL"
                                style="width: 2.5rem;height: 2.5rem;border-radius: 100%;"
                              />
                              <p
                                style="margin-top: 10px;margin-bottom: 3px;font-size: 14px;"
                              >
                                {{ item.RYXM }}
                              </p>
                              <p
                                v-if="
                                  item.AGE.length > 0 && parseInt(item.AGE) > 0
                                "
                                style="margin-top: 0px;margin-bottom: 3px;"
                              >
                                ({{ item.AGE }}岁)
                              </p>
                            </van-radio>
                          </div>
                        </van-grid-item>
                      </van-grid>
                    </van-radio-group>
                  </div>
                </div>
              </van-col>
            </van-row>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
    <!-- 单项双打  结束 -->

    <div
      style="padding:16px;"
      v-if="MRYLIST.length === 0 && WRYLIST.length === 0"
    >
      <van-row>
        <div>
          <div style="float:left;font-size:14px;color:red">
            <label>不存在待选人员</label>
          </div>
        </div>
      </van-row>
    </div>

    <!--底部按钮  开始-->
    <van-tabbar v-if="XMMAP.ISSF === '0'">
      <van-tabbar-item>
        <van-button round type="warning" @click="removeBmSave">
          取消整个项目报名
        </van-button>
      </van-tabbar-item>
      <van-tabbar-item>
        <van-button round type="primary" @click="submitHandler">
          提交数据
        </van-button>
      </van-tabbar-item>
    </van-tabbar>
    <!--底部按钮  结束-->

    <div style="height:150px;width:15px;"></div>

    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import ChangeXm from "../commonCom/ChangeXm.vue";
import { Dialog } from "vant";
export default {
  name: "TeamSelectCy",
  components: { ChangeXm, LoadingCom },
  data() {
    return {
      XMID: "",
      selectRyidCheckBoxDatas: [],
      mYbrs: 0, //男 已报人数
      wYbrs: 0, //女 已报人数
      utilPost: "",
      ssid: "",
      DWID: "",
      SSMC: "",
      DWXX: {},
      MRYLIST: [],
      WRYLIST: [],
      ISTEAM: false,
      XMMAP: {},
      teamCsSxList: [],
      sslxType: "S",
      sslxDoubleXb: "",
      sslxDoubleModal: {
        activeNames: ["0"],
        leftRadioRys: [],
        rightRadioRys: [],
        allRyLeftList: [],
        allRyRightList: []
      },
      SFZJE: 0,
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.DWID = this.$route.query.dwid;
    this.XMID = this.$route.query.xmid;
    //alert(this.DWID);
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainData();
    //this.getXmData();
  },
  methods: {
    //统计已报人数
    tjYbRs() {
      this.mYbrs = 0;
      this.wYbrs = 0;
      for (var i = 0; i < this.selectRyidCheckBoxDatas.length; i++) {
        var XB = this.selectRyidCheckBoxDatas[i].split("|")[1];
        if (XB === "M") {
          this.mYbrs++;
        } else if (XB === "W") {
          this.wYbrs++;
        }
      }
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    mainData() {
      this.selectRyidCheckBoxDatas = [];
      var busData = {
        DWID: this.DWID,
        XMID: this.XMID
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "teamChangeRyxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.teamCsSxList = data.content.teamCsSxList;
        if (this.teamCsSxList.length > 0) {
          this.ISTEAM = true;
        } else {
          this.ISTEAM = false;
        }
        this.SSMC = data.content.SSMC;
        this.XMMAP = data.content.XMMAP;
        this.sslxType = this.XMMAP.SSLX.substr(1, 2);
        this.sslxDoubleXb = this.XMMAP.SSLX.substr(0, 1);
        this.MRYLIST = JSON.parse(JSON.stringify(data.content.MRYLIST));
        this.WRYLIST = JSON.parse(JSON.stringify(data.content.WRYLIST));
        if (this.XMMAP.ISXB !== "Y") {
          for (var i = 0; i < data.content.MRYLIST.length; i++) {
            this.WRYLIST.push(data.content.MRYLIST[i]);
          }
          for (var i = 0; i < data.content.WRYLIST.length; i++) {
            this.MRYLIST.push(data.content.WRYLIST[i]);
          }
        }
        this.DWXX = data.content.DWXX;
        this.selectRyidCheckBoxDatas = data.content.selectRyidCheckBoxDatas;
        this.sslxDoubleModal.leftRadioRys = [];
        this.sslxDoubleModal.rightRadioRys = [];

        if (this.sslxType === "D") {
          for (var i = 0; i < this.selectRyidCheckBoxDatas.length; i++) {
            var array = this.selectRyidCheckBoxDatas[i].split("&");
            this.sslxDoubleModal.leftRadioRys.push(array[0]);
            this.sslxDoubleModal.rightRadioRys.push(array[1]);
          }
          if (this.sslxDoubleXb === "M") {
            this.sslxDoubleModal.allRyLeftList = this.MRYLIST;
            this.sslxDoubleModal.allRyRightList = this.MRYLIST;
          } else if (this.sslxDoubleXb === "W") {
            this.sslxDoubleModal.allRyLeftList = this.WRYLIST;
            this.sslxDoubleModal.allRyRightList = this.WRYLIST;
          } else {
            //混双
            this.sslxDoubleModal.allRyLeftList = this.MRYLIST;
            this.sslxDoubleModal.allRyRightList = this.WRYLIST;
          }
          this.doubleInitLeftOrRightCyArray();
        } else {
          this.tjYbRs();
        }
      });
    },
    boxChangeHandler() {
      if (JSON.stringify(this.XMMAP) === "{}") {
        return;
      }
      this.tjYbRs();
      if (this.XMMAP.SSLX.substr(1, 2) === "T") {
        if (this.XMMAP.ISSF === "1") {
          this.SFZJE = this.XMMAP.SFJE;
        }
      } else {
        if (this.XMMAP.ISSF === "1") {
          this.SFZJE = (
            parseFloat(this.XMMAP.SFJE) * this.selectRyidCheckBoxDatas.length
          ).toFixed(2);
        }
      }
    },
    submitHandler() {
      //alert(JSON.stringify(this.selectRyidCheckBoxDatas));
      var data = this.selectRyidCheckBoxDatas;
      if (data.length > 0) {
        var sslxType = this.XMMAP.SSLX.substr(1, 2);
        var sslxXb = this.XMMAP.SSLX.substr(0, 1);
        if (sslxType !== "T") {
          if (sslxType === "D") {
            var disArray = [];
            var isCf = false; //判断是否有重复人员
            for (var i = 0; i < data.length; i++) {
              var array = data[i].split("&");
              if (disArray.indexOf(array[0]) === -1) {
                disArray.push(array[0]);
              } else {
                isCf = true;
                break;
              }
              if (disArray.indexOf(array[1]) === -1) {
                disArray.push(array[1]);
              } else {
                isCf = true;
                break;
              }
            }
            if (isCf) {
              this.$notify({
                type: "danger",
                message: "组队人员出现重复，请检查",
                duration: 6000
              });
              return;
            }
          } else {
            // if (data.length !== 1) {
            //   this.$notify({
            //     type: "danger",
            //     message: "该项目为单打，请选择一个成员",
            //     duration: 6000
            //   });
            //   this.selectRyidCheckBoxDatas = [];
            //   return;
            // }
            if (sslxXb === "M") {
              for (var i = 0; i < data.length; i++) {
                var xb = data[i].split("|")[1];
                if (xb !== "M") {
                  this.$notify({
                    type: "danger",
                    message: "该项目为男子项目，请选择男生",
                    duration: 6000
                  });
                  this.selectRyidCheckBoxDatas = [];
                  return;
                }
              }
            }
            if (sslxXb === "W") {
              var xb = data[0].split("|")[1];
              if (xb !== "W") {
                this.$notify({
                  type: "danger",
                  message: "该项目为女子项目，请选择男生",
                  duration: 6000
                });
                this.selectRyidCheckBoxDatas = [];
                return;
              }
            }
          }
        }
      } else {
        Dialog.confirm({
          title: "提示",
          message:
            "您未选择人员，继续执行该项目会将您之前所有选中的人员进行清空,以便您重新选择"
        })
          .then(() => {})
          .catch(() => {
            return;
          });
      }
      Dialog.confirm({
        title: "提示",
        message: "是否提交"
      })
        .then(() => {
          var busData = {
            DWID: this.DWID,
            XMID: this.XMID,
            XMMAP: this.XMMAP,
            DWJC: this.DWXX.DWJC,
            selectRyidCheckBoxDatas: data
          };
          var paramData = {
            headerData: {
              ssid: this.ssid,
              op: "wapGL", //反射名称
              methodName: "insertGroupXmRyxxInfo" //对应的方法名
            },
            busData: busData //参数内容
          };
          this.utilPost.paramData = paramData;
          this.utilPost.sendPost().then(data => {
            this.$notify({
              type: "success",
              message: data.msg,
              duration: 6000
            });
            if (data.isSuccess) {
              if (this.XMMAP.ISSF === "1") {
                this.$router.push({
                  path: "/alreadyBmxx",
                  query: {
                    ssid: this.ssid
                  }
                });
              } else {
                this.$router.go(-1);
              }
            }
          });
        })
        .catch(() => {});
    },
    //取消报名
    removeBmSave() {
      if (
        !confirm(
          "是否取消该项目报名，如果取消，该项目下所有人员都将被清空,如果取消单个人员，直接点击用户头像即可"
        )
      ) {
        return;
      }
      var busData = {
        DWID: this.DWID,
        XMID: this.XMID,
        XMMAP: this.XMMAP,
        DWJC: this.DWXX.DWJC
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "removeXmRyxxInfo" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        this.$notify({
          type: "success",
          message: data.msg,
          duration: 3000
        });
        if (data.isSuccess) {
          this.$router.go(-1);
        }
      });
    },
    //双打使用
    radioChangeHandler(fx, index) {
      // alert(JSON.stringify(this.sslxDoubleModal.leftRadioRys));
      // alert(JSON.stringify(this.sslxDoubleModal.rightRadioRys));
      if (
        this.sslxDoubleModal.rightRadioRys[index].length === 0 &&
        this.sslxDoubleModal.leftRadioRys[index].length === 0
      ) {
        return;
      }
      if (
        this.sslxDoubleModal.rightRadioRys[index] ===
        this.sslxDoubleModal.leftRadioRys[index]
      ) {
        if (fx === "L") {
          this.$notify({
            type: "danger",
            message: "不能与右侧人员相同",
            duration: 3000
          });
          this.sslxDoubleModal.leftRadioRys.splice(index, 1, "");
        } else {
          this.$notify({
            type: "danger",
            message: "不能与左侧人员相同",
            duration: 3000
          });
          this.sslxDoubleModal.rightRadioRys.splice(index, 1, ""); //[index] = "";
        }
        return;
      }

      var leftData = this.sslxDoubleModal.leftRadioRys[index];
      var rightData = this.sslxDoubleModal.rightRadioRys[index];
      if (
        leftData !== undefined &&
        leftData.length > 0 &&
        rightData !== undefined &&
        rightData.length > 0
      ) {
        var data = leftData + "&" + rightData;
        this.selectRyidCheckBoxDatas.splice(index, 1, data);

        var data = this.selectRyidCheckBoxDatas;
        var disArray = [];
        var isCf = false; //判断是否有重复人员
        for (var i = 0; i < data.length; i++) {
          var array = data[i].split("&");
          if (disArray.indexOf(array[0]) === -1) {
            disArray.push(array[0]);
          } else {
            isCf = true;
            break;
          }
          if (disArray.indexOf(array[1]) === -1) {
            disArray.push(array[1]);
          } else {
            isCf = true;
            break;
          }
        }
        if (isCf) {
          this.selectRyidCheckBoxDatas.splice(index, 1, "");
          this.$notify({
            type: "danger",
            message: "组队人员出现重复，请检查",
            duration: 6000
          });
          if (fx === "L") {
            this.sslxDoubleModal.leftRadioRys[index] = "";
          } else {
            this.sslxDoubleModal.rightRadioRys[index] = "";
          }
          return;
        }
      }
    },
    //双打时增加人员组使用
    sslxDoubleAddCy() {
      this.selectRyidCheckBoxDatas.push("");
      this.sslxDoubleModal.leftRadioRys.push("");
      this.sslxDoubleModal.rightRadioRys.push("");
      this.sslxDoubleModal.activeNames = [
        this.selectRyidCheckBoxDatas.length - 1
      ];
      if (this.XMMAP.ISSF === "1") {
        this.SFZJE = (
          parseFloat(this.XMMAP.SFJE) * this.selectRyidCheckBoxDatas.length
        ).toFixed(2);
      }
    },
    sslxDoubleRemoveCy(index) {
      if (!confirm("是否移除？")) {
        return;
      }
      this.selectRyidCheckBoxDatas.splice(index, 1);
      this.sslxDoubleModal.leftRadioRys.splice(index, 1);
      this.sslxDoubleModal.rightRadioRys.splice(index, 1);
      if (this.XMMAP.ISSF === "1") {
        this.SFZJE = (
          parseFloat(this.XMMAP.SFJE) * this.selectRyidCheckBoxDatas.length
        ).toFixed(2);
      }
    },
    //重构左侧人员和右侧人员
    doubleInitLeftOrRightCyArray() {
      // var selectRyidCheckBoxDatas = this.selectRyidCheckBoxDatas;
      // //处理左侧人员
      // for (var i = 0; i < this.sslxDoubleModal.allRyLeftList.length; i++) {
      //   var RYID = this.sslxDoubleModal.allRyLeftList[i].RYID;
      //   var isDel = false;
      //   for (var p = 0; p < selectRyidCheckBoxDatas.length; p++) {
      //     var array = selectRyidCheckBoxDatas[p].split("&");
      //     var selectRyid1 = array[0].split("|")[0];
      //     var selectRyid2 = array[1].split("|")[0];
      //     if (selectRyid1 === RYID) {
      //       isDel = true;
      //     }
      //     if (selectRyid2 === RYID) {
      //       isDel = true;
      //     }
      //   }
      //   if (isDel) {
      //     this.sslxDoubleModal.allRyLeftList.splice(i, 1);
      //   }
      // }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.van-button--warning,
.van-button--primary {
  width: 150px;
  height: 35px;
}
/deep/ .van-checkbox__icon--round {
  position: absolute;
  top: 0px;
  left: -15px;
}
/deep/ .van-collapse-item__content {
  padding: 12px 8px;
}
/deep/ .van-radio__icon {
  position: absolute;
  top: 0px;
  left: -19px;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/TeamSelectCy.vue